export enum LocalePrefixesEnum {
  EN = 'en',
  AT = 'at',
  DE = 'de',
  // CH = 'ch',
}
